
import React from 'react'
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap'

import Component from '../Component'

export default class NavTabs extends Component
{
	constructor(props)
	{
		super(props)

		this.state = {
			activeTab: this.props.active || this.props.tabs[0],
		};
	}

	onChange(tab)
	{
		if (this.state.activeTab.title == tab.title) {
			return;
		}

		this.setState({
			activeTab: tab
		});

		this.props.onChange(tab);
	}

	renderStatusSelection()
	{
		let tabs = this.props.tabs,
			activeTab = this.state.activeTab;

		return (
			<div className="my-4 flex justify-center flex-wrap">
				{tabs.map((tab,i) => {
					let isActive = activeTab.title == tab.title;

					return (
						<button key={`teamListType${i}`}
							className={'btn btn-tab ' + (isActive && 'active')}
							style={styles.tabBtn}
							onClick={() => this.onChange(tab)}>
							{tab.title} {TB.isNumber(tab.counts) && (
								<small>({tab.counts})</small>
							)}
						</button>
					);
				})}
			</div>
		);
	}

    renderStatusDropdown()
    {
		let tabs = this.props.tabs,
			activeTab = this.state.activeTab;

    	return (
    		<Dropdown className='filter-dropdown py-2 m-3'
    			style={styles.tabDropdown}
    			isOpen={this.state.statusDropdown}
				toggle={() => {
					this.promisedState(prevState => ({
				    	statusDropdown: !this.state.statusDropdown
				    }));
				}}>

				<DropdownToggle caret tag="a"
					style={{cursor: 'pointer'}}>
					{activeTab.title} {TB.isNumber(activeTab.counts) && (
						<small>({activeTab.counts})</small>
					)}
				</DropdownToggle>

				<DropdownMenu>
					{tabs.map((tab,i) => {
						return (
							<DropdownItem key={`sortItem${i}`}
								style={{fontSize: '12px'}}
								onClick={() => this.onChange(tab)}>
								{tab.title} {TB.isNumber(tab.counts) && (
									<small>({tab.counts})</small>
								)}
							</DropdownItem>
						);
					})}
				</DropdownMenu>
			</Dropdown>
    	);
    }

	render()
	{
		return (
			<div className="flex flex-row justify-center">

				{
				    !this.props.hideTabs ?
                        this.renderStatusSelection() :
                    this.renderStatusDropdown()
				}

			</div>
    	);
	}
}

const styles = {
	tabBtn: {
		margin: '10px',
	    borderRadius: 'unset',
	    fontSize: '12px',
	    width: 160,
	},
	tabDropdown: {
	    alignSelf: 'stretch',
	    textAlign: 'center',
	    border: '1px solid rgb(25, 42, 62)',
	    boxSizing: 'border-box',
	    fontWeight: 600,
	    fontSize: '13px',
	    lineHeight: '19px',
	    letterSpacing: '0.01em',
	},
};